import request from './request'

const desktopApi = () => (typeof window !== 'undefined' ? window.ibotDesktop : null)

export const isDesktopApp = () => !!desktopApi()?.isElectron

const isApiSuccess = (body) => {
  if (!body) return false
  return body.code === 200 || body.code === 0 || body.success === true
}

const parseVersionParts = (version) => {
  return String(version || '')
    .trim()
    .replace(/^[vV]/, '')
    .split(/[.+-]/)
    .map((part) => parseInt(part, 10) || 0)
}

export const isNewerVersion = (remote, local) => {
  if (!remote) return false
  if (!local) return true
  if (String(remote) === String(local)) return false
  const remoteParts = parseVersionParts(remote)
  const localParts = parseVersionParts(local)
  const length = Math.max(remoteParts.length, localParts.length)
  for (let i = 0; i < length; i++) {
    const a = remoteParts[i] || 0
    const b = localParts[i] || 0
    if (a > b) return true
    if (a < b) return false
  }
  return false
}

export const getManufacturer = (platform, arch) => {
  if (platform === 'win32' || platform === 'windows') return 'windows'
  if (platform === 'darwin' || platform === 'mac') {
    if (arch === 'arm64' || arch === 'apple') return 'apple'
    return 'mac'
  }
  return 'all'
}

const getUniqueId = () => {
  const stored = localStorage.getItem('uniqueId')
  if (stored != null && stored !== '') {
    const id = Number(stored)
    if (Number.isFinite(id)) return id
  }
  try {
    const user = JSON.parse(localStorage.getItem('userInfo') || 'null')
    const id = Number(user?.uniqueId)
    return Number.isFinite(id) ? id : undefined
  } catch {
    return undefined
  }
}

export const sanitizeUpdateLog = (html) => {
  return String(html || '')
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/javascript:/gi, '')
}

export const getDesktopAppInfo = async () => {
  const desktop = desktopApi()
  if (!desktop) return null
  if (typeof desktop.getAppInfo === 'function') {
    const info = await desktop.getAppInfo()
    if (info?.version) return info
  }
  return {
    version: '',
    platform: desktop.platform
  }
}

export const openDesktopExternal = async (url) => {
  const desktop = desktopApi()
  if (typeof desktop?.openExternal === 'function') {
    return desktop.openExternal(url)
  }
  window.open(url, '_blank', 'noopener,noreferrer')
  return { ok: true }
}

export const queryAppVersion = async () => {
  if (!isDesktopApp()) return null

  const info = await getDesktopAppInfo()
  if (!info?.version) return null

  const payload = {
    clientVersion: info.version,
    manufacturer: info.manufacturer || getManufacturer(info.platform, info.arch)
  }
  const uniqueId = getUniqueId()
  if (uniqueId != null) payload.uniqueId = uniqueId

  const response = await request.post('/app/android/version/query', payload)
  const body = response.data
  if (!isApiSuccess(body) || !body.data) return null

  const data = body.data
  const nowVersion = data.nowVersion
  if (!isNewerVersion(nowVersion, info.version)) return null

  return {
    ...data,
    clientVersion: info.version,
    manufacturer: payload.manufacturer,
    forceUpdate: data.updatedStatus === 1 || data.updatedStatus === '1',
    updatedLog: sanitizeUpdateLog(data.updatedLog)
  }
}
